import React, { useMemo } from "react";
import Dropdown from "./Dropdown";
import { INDUSTRIES } from "../../constants/industries";

type Props = {
    valueCode: string | undefined;
    onChangeCode: (code: string) => void;
    placeholder?: string;
    className?: string;
    searchable?: boolean;
};

const IndustryDropdown: React.FC<Props> = ({
    valueCode,
    onChangeCode,
    placeholder = "Select an industry",
    className,
    searchable = true,
}) => {
    const options = useMemo(
        () =>
            INDUSTRIES.map((i) => ({
                name: i,
                code: i,
            })),
        []
    );

    const selectedOption = useMemo(
        () => options.find((o) => o.code === valueCode) ?? null,
        [options, valueCode]
    );

    return (
        <Dropdown
            options={options}
            value={selectedOption}
            onChange={(opt) => onChangeCode(String(opt?.code ?? ""))}
            placeholder={placeholder}
            className={className}
            searchable={searchable}
        />
    );
};

export default IndustryDropdown;
